import { useEffect, useState } from "react";
import KPIService from "services/KPIService";

import {
  Table,
  TableBody,
  TableCell,
  TableRow
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import dayjs from "dayjs";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

export default function HistoryLogTable({ draftId }) {
  const classes = useStyles();
  const [historyLog, setHistoryLog] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const hasDataList = !!(!isLoading && historyLog.length);

  useEffect(() => {
    if (draftId) {
      const init = async () => {
        try {
          setIsLoading(true)
          setHistoryLog([])
          const res = await KPIService.getKPIDocumentLog(draftId)
          setHistoryLog(res.results)
          setIsLoading(false)
        } catch (error) {
          setIsLoading(false)
        }
      }

      init()
    }
  }, [draftId])

  return (
    <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <StyledTableCell align="center" style={{ width: 50 }}>
              Doc No.
            </StyledTableCell>
            <StyledTableCell>Date</StyledTableCell>
            <StyledTableCell>Employee</StyledTableCell>
            <StyledTableCell>Status</StyledTableCell>
            <StyledTableCell>Edit data</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading && (
            <TableRow style={{ borderTop: 1 }}>
              <TableCell colSpan={5} align="center">
                Loading...
              </TableCell>
            </TableRow>
          )}
          {!hasDataList && (
            <TableRow>
              <TableCell colSpan={5} align="center">
                No history log data.
              </TableCell>
            </TableRow>
          )}
          {hasDataList && !isLoading && (
            historyLog.map((item) => (
              <TableRow key={item.draftId} style={{ borderTop: 1 }}>
                <TableCell>
                  {item.smartNo}
                </TableCell>
                <TableCell>
                  {item.date ? dayjs(item.date).format('YYYY/MM/DD HH:mm:ss') : '-'}
                </TableCell>
                <TableCell>
                  {(item.staffFirstname || item.staffLastname) ? [item.staffFirstname, item.staffLastname].filter(Boolean).join(' ') : '-'}
                </TableCell>
                <TableCell>
                  {item.statusname ?? '-'}
                </TableCell>
                <TableCell>
                  {item.isEditData ?? '-'}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
